import React from "react";

class FormInputText extends React.Component {
  constructor(props) {
    super(props);
  }
  previeniAsterisco(e) {
    if (e.keyCode == 187) {
      //Prevengo l'inserimento dell'asterisco
      e.preventDefault();
      return false;
    }
  }
  render() {
    let error = this.props.error ? this.props.error : "";

    return (
      <div
        className={`inputContainer ${this.props.class} ${
          error == "" && this.props.value != "" ? "valid" : ""
          } ${
          this.props.error != "" && this.props.value != "" ? "notValid" : ""
          } ${this.props.value != "" ? "filled" : ""}`}
      >
        <input
          type={this.props.type}
          onKeyDown={this.previeniAsterisco}
          id={this.props.elid}
          data-validation={this.props.validate}
          name={this.props.name}
          onClick={this.props.click}
          onKeyUp={this.props.kup}
          onChange={this.props.handler.bind(this, this.props.validate)}
          onBlur={this.props.blur}
          value={this.props.value}
          disabled={this.props.disabled}
          autoComplete="off"
        />
        <label>{this.props.label}</label>
        <div className="error">{this.props.error}</div>
        <div className="icon">
          <img src="./img/check.png" />
        </div>
      </div>
    );
  }
}

export default FormInputText;


// WEBPACK FOOTER //
// ./src/components/shared/FormInputText/index.js